import React, { useEffect, useState } from "react";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";
import { previewDevices, tabContent } from "./GoogleAutomationConstants";
import img from "../../assets/icons/leadTemplate.png";
import Select, { components } from "react-select";
import InncreaseCampaignBudgetForm from "./InncreaseCampaignBudgetForm";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  Adsetname: Yup.string().required("Ad set name is required"),
  performanceGoal: Yup.object().shape({
    label: Yup.string().required("Performance Goal is required"),
    value: Yup.string().required("Performance Goal is required"),
  }),
  facebookPage: Yup.object().shape({
    label: Yup.string().required("Facebook Page is required"),
    value: Yup.string().required("Facebook Page is required"),
  }),
  costPerResult: Yup.object().required("Cost Per Result is required"),
  budgetType: Yup.object().required("Budget Type is required"),
  budgetAmount: Yup.number().required("Budget is required"),
  scheduleStartDate: Yup.string().required("Schedule Start Date is required"),
  scheduleStartTime: Yup.string().required("Schedule Start Time is required"),
  scheduleEndDate: Yup.string().required("Schedule End Date is required"),
  scheduleEndTime: Yup.string().required("Schedule End Time is required"),
  adScheduling: Yup.string().nullable().optional(),
  location: Yup.array().required("Location is required"),
  include: Yup.object().required("Include is required"),
  minimumAge: Yup.object().required("Minimum Age is required"),
  exclude: Yup.string().nullable().optional(), // .required("Exclude is required"),
  languages: Yup.object().required("Languages is required"),
  existingAudience: Yup.object().required("Existing Audience is required"),
  createNewAudience: Yup.object().required("Create New Audience is required"),
  minAge: Yup.object().required("Minimum Age is required"),
  maxAge: Yup.object().required("Maximum Age is required"),
  gender: Yup.object().required("Gender is required"),
  placement: Yup.string().required("Placement is required"),

  budgetIncrease: Yup.boolean(),

  startDate: Yup.date().when("budgetIncrease", {
    is: true,
    then: (schema) => schema.required("Start date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  startTime: Yup.string().when("budgetIncrease", {
    is: true,
    then: (schema) => schema.required("Start time is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  endDate: Yup.date().when("budgetIncrease", {
    is: true,
    then: (schema) => schema.required("End date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  endTime: Yup.string().when("budgetIncrease", {
    is: true,
    then: (schema) => schema.required("End time is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  bidStrategy: Yup.string().when("budgetIncrease", {
    is: true,
    then: (schema) => schema.required("Bid Strategy is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  bidAmount: Yup.number().when("budgetIncrease", {
    is: true,
    then: (schema) =>
      schema
        .min(1, "Amount must be greater than zero")
        .required("Amount is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const AdsetName = ({
  setIsFormFourValid,
  setFormFourValue,
  formFourValue,
  reactSelectStyles,
}) => {
  const [showBudgetIncreaseForm, setShowBudgetIncreaseForm] = useState(false);
  const [selected, setSelected] = useState("advantage");
  const handleBudgetIncreaseCheck = (e, setFieldValue) => {
    setFieldValue("budgetIncrease", e.target.checked);
    if (e.target.checked) {
      setShowBudgetIncreaseForm(true);
    } else {
      setShowBudgetIncreaseForm(false);
      setFieldValue("startDate", "");
      setFieldValue("startTime", "");
      setFieldValue("endDate", "");
      setFieldValue("endTime", "");
      setFieldValue("bidStrategy", "");
      setFieldValue("bidAmount", "");
    }
  };
  return (
    <div
      className="campaign-budget-container pt-5 pb-40 h-[90vh] overflow-scroll "
      // style={{
      //   minHeight: "400px",
      //   overflowY: "scroll",
      //   height: "480px",
      //   paddingLeft: "10px",
      // }}
    >
      <Formik
        initialValues={{
          Adsetname: formFourValue.Adsetname || "",
          performanceGoal: formFourValue.performanceGoal || "",
          facebookPage: formFourValue.facebookPage || "",
          costPerResult: formFourValue.costPerResult || null,
          budgetType: formFourValue.budgetType || "",
          budgetAmount: formFourValue.budgetAmount || "",
          scheduleStartDate: formFourValue.scheduleStartDate || "",
          scheduleStartTime: formFourValue.scheduleStartTime || "",
          scheduleEndDate: formFourValue.scheduleEndDate || "",
          scheduleEndTime: formFourValue.scheduleEndTime || "",
          budgetIncrease: formFourValue.budgetIncrease || false,
          adScheduling: formFourValue.adScheduling || "",
          location: formFourValue.location || "",
          include: formFourValue.include || "",
          minimumAge: formFourValue.minimumAge || "",
          exclude: formFourValue.exclude || "",
          languages: formFourValue.languages || "",
          existingAudience: formFourValue.existingAudience || "",
          createNewAudience: formFourValue.createNewAudience || "",
          minAge: formFourValue.minAge || "",
          maxAge: formFourValue.maxAge || "",
          gender: formFourValue.gender || "",
          placement: formFourValue.placement || "advantage",
          bidStrategy: formFourValue.bidStrategy || "",
          startDate: formFourValue.startDate || "",
          startTime: formFourValue.startTime || "",
          endDate: formFourValue.endDate || "",
          endTime: formFourValue.endTime || "",
          bidAmount: formFourValue.bidAmount || "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("Form submitted", values);
        }}
      >
        {({ errors, touched, isValid, dirty, values, setFieldValue }) => {
          if (dirty) {
            setIsFormFourValid(isValid && dirty);
            setFormFourValue(values);
          }

          return (
            <Form className="campaign-budget-container">
              <div className="create-form-item" style={{ marginTop: "10px" }}>
                <div className="f-bold f-14">Ad set name</div>
                <div className="common-input-container" data-label="Adset Name">
                  {/* <input type="text" placeholder="eg Adglobal360 Festive" /> */}
                  <Field
                    type="text"
                    name="Adsetname"
                    placeholder="eg Adglobal360 Festive"
                  />
                  <ErrorMessage
                    name="Adsetname"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <div>
                <div
                  style={{ fontWeight: "bold", marginBottom: "20px" }}
                  className="f-16"
                >
                  Awareness
                </div>
                <div className="create-form-item">
                  <div>
                    <div
                      className="f-14"
                      style={{ fontWeight: "bold", marginBottom: "2px" }}
                    >
                      Performance Goal
                    </div>
                    <p className="description" style={{ marginBottom: "20px" }}>
                      How you measure success for your Ads.
                    </p>
                    <div
                      className="common-type-container"
                      data-label="Adset Name"
                    >
                      {/* <Select
              placeholder="Creative"
              options={[
                { label: "Highest Volume", value: "Highest" },
                { label: "Lowest Volume", value: "Lowest" },
              ]}
              styles={reactSelectStyles}
              // value={adType}
              // onChange={handleAdTypeChange}
            /> */}

                      <Select
                        styles={reactSelectStyles}
                        placeholder="Creative"
                        options={[
                          { label: "Highest Volume", value: "Highest" },
                          { label: "Lowest Volume", value: "Lowest" },
                        ]}
                        onChange={(option) =>
                          setFieldValue("performanceGoal", option)
                        }
                        value={values.performanceGoal}
                      />
                      <ErrorMessage
                        name="performanceGoal.label"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div>
                    <div
                      className="f-14"
                      style={{ fontWeight: "bold", marginBottom: "2px" }}
                    >
                      Facebook Page
                    </div>
                    <p className="description" style={{ marginBottom: "20px" }}>
                      Choose the page you want to promote.
                    </p>
                    <div
                      className="common-type-container"
                      data-label="Page Name"
                    >
                      {/* <Select
              placeholder="Creative"
              options={[
                { label: "Highest Volume", value: "Highest" },
                { label: "Lowest Volume", value: "Lowest" },
              ]}
              styles={reactSelectStyles}

              // value={adType}
              // onChange={handleAdTypeChange}
            /> */}
                      <Select
                        styles={reactSelectStyles}
                        placeholder="Creative"
                        options={[
                          { label: "Highest Volume", value: "Highest" },
                          { label: "Lowest Volume", value: "Lowest" },
                        ]}
                        onChange={(option) =>
                          setFieldValue("facebookPage", option)
                        }
                        value={values.facebookPage}
                      />
                      <ErrorMessage
                        name="facebookPage.label"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div>
                    <div
                      className="f-14"
                      style={{ fontWeight: "bold", marginBottom: "2px" }}
                    >
                      Cost Per Result Goal: Optional
                    </div>
                    <p className="description" style={{ marginBottom: "20px" }}>
                      Choose the page you want to promote.
                    </p>
                    <div
                      className="common-type-container"
                      data-label="Page Name"
                    >
                      {/* <Select
              placeholder="Creative"
              options={[
                { label: "Highest Volume", value: "Highest" },
                { label: "Lowest Volume", value: "Lowest" },
              ]}
              styles={reactSelectStyles}

              // value={adType}
              // onChange={handleAdTypeChange}
            /> */}

                      <Select
                        styles={reactSelectStyles}
                        placeholder="Creative"
                        options={[
                          { label: "Highest Volume", value: "Highest" },
                          { label: "Lowest Volume", value: "Lowest" },
                        ]}
                        onChange={(option) =>
                          setFieldValue("costPerResult", option)
                        }
                        value={values.costPerResult}
                      />
                      <ErrorMessage
                        name="costPerResult.label"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                </div>
                <p className="description">
                  Meta will aim to spend your entire budget and get the most
                  1,000 impressions using the highest volume bid strategy. If
                  keeping the average cost per result around a certain amount is
                  important, enter a cost per result goal.
                </p>
              </div>
              <div className="fc-cards-container">
                {/* Frequency Cap Card */}
                <div className="fc-card">
                  <div className="fc-card-header">
                    <span>Frequency cap</span>
                    <span className="fc-icon-edit">
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="fc-card-body">
                    <p className="fc-info-text">
                      Default - 1 impression every 7 days
                    </p>
                    <p className="fc-info-text">
                      You can now find information about when you get charged
                      for ads in the Help Center.
                    </p>
                    <a href="#" className="link">
                      How Meta charges for ads
                    </a>
                  </div>
                </div>

                {/* Delivery Type Card */}
                <div className="fc-card">
                  <div className="fc-card-header">
                    <span>Delivery type</span>
                    <span className="fc-icon-edit">
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="fc-card-body">
                    <p className="fc-info-text">Standard</p>
                  </div>
                </div>
              </div>
              <div
                className="create-form-item"
                // style={{ flexDirection: "column", alignItems: "start", gap: "0px" }}
              >
                <div>
                  <div className="f-16" style={{ fontWeight: "bold" }}>
                    Dynamic Creative
                  </div>
                  <p className="description">
                    We'll automatically create combination of your media and
                    text that your audience is likely to respond to.
                  </p>
                  <p className="link">About dynamic creative</p>
                </div>
              </div>
              <div
                className="create-form-item"
                // style={{ flexDirection: "column", alignItems: "start", gap: "0px" }}
              >
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Budget & Schedule
                  </div>
                </div>
              </div>
              <div
                className="create-form-item"
                style={{ width: "min-content", alignItems: "flex-start" }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "bold",
                      marginBottom: "2px",
                      marginBottom: "15px",
                    }}
                    className="f-14"
                  >
                    Budget
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      className="common-type-container"
                      style={{ width: "150px" }}
                      data-label="starts-on"
                    >
                      {/* <Select
              placeholder="Select"
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  borderTopRightRadius: "0px",
                  borderBottomRightRadius: "0px",
                  outline: "none",
                  borderColor: state.isFocused ? "lightgray" : "lightgray",
                  "&:hover": {
                    borderColor: "lightgray",
                  },
                  fontSize: "12px",
                  boxShadow: "none",
                }),
                input: (provided) => ({
                  ...provided,
                  fontSize: "12px",
                }),
                menu: (provided) => ({
                  ...provided,
                  fontSize: "12px",
                }),
                menuList: (provided) => ({
                  ...provided,
                  fontSize: "12px",
                }),
                option: (provided, state) => ({
                  ...provided,
                  fontSize: "12px",
                }),
              }}
              options={[
                { label: "Daily Budget", value: "DB" },
                { label: "Daily Budget", value: "DB" },
              ]}

              // value={adType}
              // onChange={handleAdTypeChange}
            /> */}

                      <Select
                        placeholder="Select"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                            outline: "none",
                            borderColor: state.isFocused
                              ? "lightgray"
                              : "lightgray",
                            "&:hover": {
                              borderColor: "lightgray",
                            },
                            fontSize: "12px",
                            boxShadow: "none",
                          }),
                          input: (provided) => ({
                            ...provided,
                            fontSize: "12px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            fontSize: "12px",
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            fontSize: "12px",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            fontSize: "12px",
                          }),
                        }}
                        options={[
                          { label: "Daily Budget", value: "DB" },
                          { label: "Daily Budget", value: "DB" },
                        ]}
                        onChange={(option) =>
                          setFieldValue("budgetType", option)
                        }
                        value={values.budgetType}
                      />
                      <ErrorMessage
                        name="budgetType.label"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div
                      className="currency-input-container"
                      style={{ width: "150px" }}
                    >
                      {/* <input
              type="text"
              style={{
                borderBottomLeftRadius: "0px",
                borderTopLeftRadius: "0px",
                height: "38px",
                borderBottomRightRadius: "5px",
                borderTopRightRadius: "5px",
                border: "1px solid lightgray",
              }}
              placeholder="eg. 200 INR"
            /> */}
                      <Field
                        type="number"
                        name="budgetAmount"
                        placeholder="eg. 200 INR"
                        style={{
                          borderBottomLeftRadius: "0px",
                          borderTopLeftRadius: "0px",
                          height: "38px",
                          borderBottomRightRadius: "5px",
                          borderTopRightRadius: "5px",
                          border: "1px solid lightgray",
                        }}
                      />
                      <ErrorMessage
                        name="budgetAmount"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <p className="description">
                    You will spend an average of ₹ 200.00 per day. Your maximum
                    daily spend is ₹ 350.00 and your maximum weekly spend is ₹
                    1400.00
                  </p>
                  <p className="link">About daily budget</p>
                </div>
                <div>
                  <div
                    style={{
                      fontWeight: "bold",
                      marginBottom: "2px",
                      marginBottom: "15px",
                    }}
                    className="f-14"
                  >
                    Schedule
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      className="common-input-container"
                      style={{ width: "150px" }}
                      data-label="start-date"
                    >
                      {/* <input
              type="date"
              style={{
                borderBottomRightRadius: "0px",
                borderTopRightRadius: "0px",
                height: "38px",
                borderBottomLeftRadius: "5px",
                borderTopLeftRadius: "5px",
                border: "1px solid lightgray",
              }}
            /> */}

                      <Field
                        type="date"
                        name="scheduleStartDate"
                        style={{
                          borderBottomRightRadius: "0px",
                          borderTopRightRadius: "0px",
                          height: "38px",
                          borderBottomLeftRadius: "5px",
                          borderTopLeftRadius: "5px",
                          border: "1px solid lightgray",
                        }}
                      />
                      <ErrorMessage
                        name="scheduleStartDate"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div
                      className="common-input-container"
                      style={{ width: "150px" }}
                    >
                      {/* <input
              type="time"
              style={{
                borderBottomLeftRadius: "0px",
                borderTopLeftRadius: "0px",
                height: "38px",
                borderBottomRightRadius: "5px",
                borderTopRightRadius: "5px",
                border: "1px solid lightgray",
              }}
            /> */}
                      <Field
                        type="time"
                        name="scheduleStartTime"
                        style={{
                          borderBottomLeftRadius: "0px",
                          borderTopLeftRadius: "0px",
                          height: "38px",
                          borderBottomRightRadius: "5px",
                          borderTopRightRadius: "5px",
                          border: "1px solid lightgray",
                        }}
                      />
                      <ErrorMessage
                        name="scheduleStartTime"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "10px",
                      marginBottom: "23px",
                    }}
                  >
                    <div
                      className="common-input-container"
                      style={{ width: "150px" }}
                      data-label="End-date"
                    >
                      {/* <input
              type="date"
              style={{
                borderBottomRightRadius: "0px",
                borderTopRightRadius: "0px",
                height: "38px",
                borderBottomLeftRadius: "5px",
                borderTopLeftRadius: "5px",
                border: "1px solid lightgray",
              }}
            /> */}
                      <Field
                        type="date"
                        name="scheduleEndDate"
                        style={{
                          borderBottomRightRadius: "0px",
                          borderTopRightRadius: "0px",
                          height: "38px",
                          borderBottomLeftRadius: "5px",
                          borderTopLeftRadius: "5px",
                          border: "1px solid lightgray",
                        }}
                      />
                      <ErrorMessage
                        name="scheduleEndDate"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div
                      className="common-input-container"
                      style={{ width: "150px" }}
                    >
                      {/* <input
              type="time"
              style={{
                borderBottomLeftRadius: "0px",
                borderTopLeftRadius: "0px",
                height: "38px",
                borderBottomRightRadius: "5px",
                borderTopRightRadius: "5px",
                border: "1px solid lightgray",
              }}
            /> */}

                      <Field
                        type="time"
                        name="scheduleEndTime"
                        style={{
                          borderBottomLeftRadius: "0px",
                          borderTopLeftRadius: "0px",
                          height: "38px",
                          borderBottomRightRadius: "5px",
                          borderTopRightRadius: "5px",
                          border: "1px solid lightgray",
                        }}
                      />
                      <ErrorMessage
                        name="scheduleEndTime"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="create-form-item" style={{ alignItems: "unset" }}>
                {" "}
                <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Budget Scheduling
                </div>
                <div className="input-container-check">
                  {/* <input type="checkbox" onChange={handleBudgetIncreaseCheck} /> */}
                  <Field
                    type="checkbox"
                    name="budgetIncrease"
                    onChange={(e) => {
                      handleBudgetIncreaseCheck(e, setFieldValue);
                    }}
                  />
                  <ErrorMessage
                    name="budgetIncrease"
                    component="div"
                    className="error-message"
                  />

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <p style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                      Schedule Budget Increases
                    </p>
                    <p className="spend-info" style={{ marginTop: "0px" }}>
                      Increase your budget during specific days or times.
                    </p>
                    {showBudgetIncreaseForm && <InncreaseCampaignBudgetForm />}
                  </div>
                </div>
              </div>
              <div className="create-form-item" style={{ alignItems: "unset" }}>
                {" "}
                <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Ad Scheduling
                </div>
                <div className="input-container-check">
                  {/* <input type="checkbox" /> */}
                  <Field type="checkbox" name="adScheduling" />
                  <ErrorMessage
                    name="adScheduling"
                    component="div"
                    className="error-message"
                  />

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <p style={{ fontWeight: "light", whiteSpace: "nowrap" }}>
                      Run ads on a schedule.
                    </p>
                  </div>
                </div>
              </div>
              <div className="create-form-item" style={{ alignItems: "unset" }}>
                <p className="link">+ Show more options</p>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                  Audience Controls
                </div>
                <p className="description">
                  Set criteria for where ads for this campaign can be delivered.
                </p>
                <p className="link">Learn more</p>
              </div>
              <div className="create-form-item" style={{ alignItems: "unset" }}>
                {" "}
                <div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Locations
                  </div>
                  <p className="description">
                    Reach people living in or recently in this location.
                  </p>
                </div>
              </div>
              <div className="create-form-item">
                <div className="common-type-container" data-label="Location">
                  {/* <Select
          placeholder="Select"
          options={[
            { label: "India", value: "Ind" },
            { label: "Japan", value: "Jap" },
          ]}
          styles={reactSelectStyles}
        /> */}
                  <Select
                    styles={reactSelectStyles}
                    placeholder="Select"
                    options={[
                      { label: "India", value: "Ind" },
                      { label: "Japan", value: "Jap" },
                    ]}
                    isMulti
                    onChange={(selectedOptions) =>
                      setFieldValue("location", selectedOptions)
                    }
                    value={values.location}
                  />
                  <ErrorMessage
                    name="location"
                    component="div"
                    className="text-red-500"
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    className="common-type-container"
                    style={{ width: "150px" }}
                    data-label="Include"
                  >
                    {/* <Select
            placeholder="Include"
            styles={{
              control: (provided, state) => ({
                ...provided,
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
                outline: "none",
                borderColor: state.isFocused ? "lightgray" : "lightgray",
                "&:hover": {
                  borderColor: "lightgray",
                },
                fontSize: "12px",
                boxShadow: "none",
              }),
              input: (provided) => ({
                ...provided,
                fontSize: "12px",
              }),
              menu: (provided) => ({
                ...provided,
                fontSize: "12px",
              }),
              menuList: (provided) => ({
                ...provided,
                fontSize: "12px",
              }),
              option: (provided, state) => ({
                ...provided,
                fontSize: "12px",
              }),
            }}
            options={[
              { label: "Daily Budget", value: "DB" },
              { label: "Daily Budget", value: "DB" },
            ]}
          /> */}

                    <Select
                      placeholder="Include"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          borderTopRightRadius: "0px",
                          borderBottomRightRadius: "0px",
                          outline: "none",
                          borderColor: state.isFocused
                            ? "lightgray"
                            : "lightgray",
                          "&:hover": {
                            borderColor: "lightgray",
                          },
                          fontSize: "12px",
                          boxShadow: "none",
                        }),
                        input: (provided) => ({
                          ...provided,
                          fontSize: "12px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          fontSize: "12px",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          fontSize: "12px",
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          fontSize: "12px",
                        }),
                      }}
                      options={[
                        { label: "Daily Budget", value: "DB" },
                        { label: "Daily Budget", value: "DB" },
                      ]}
                      onChange={(selectedOptions) =>
                        setFieldValue("include", selectedOptions)
                      }
                      value={values.include}
                    />
                    <ErrorMessage
                      name="include"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                  <div
                    className="search-input-container"
                    style={{ width: "250px" }}
                  >
                    <input
                      type="text"
                      style={{
                        borderBottomLeftRadius: "0px",
                        borderTopLeftRadius: "0px",
                        height: "38px",
                        borderBottomRightRadius: "5px",
                        borderTopRightRadius: "5px",
                        border: "1px solid lightgray",
                      }}
                      placeholder="Search here"
                    />
                    <svg
                      style={{ position: "absolute", left: "7px", top: "20%" }}
                      className="w-6 h-6 text-gray-800 dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="20"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="#3b82f6"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="fc-cards-container">
                <div className="fc-card w-228">
                  <div className="fc-card-header" style={{ fontSize: "12px" }}>
                    <span>Minmum Age</span>
                    <span className="fc-icon-edit">
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="fc-card-body" style={{ padding: "10px 0" }}>
                    <div className="common-type-container" data-label="Age">
                      {/* <Select
              placeholder="select age"
              options={[
                { label: "18", value: "18" },
                { label: "19", value: "19" },
              ]}
              styles={reactSelectStyles}
            /> */}

                      <Select
                        styles={reactSelectStyles}
                        placeholder="select age"
                        options={[
                          { label: "18", value: "18" },
                          { label: "19", value: "19" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("minimumAge", selectedOptions)
                        }
                        value={values.minimumAge}
                      />
                      <ErrorMessage
                        name="minimumAge"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </div>
                </div>

                <div className="fc-card w-228">
                  <div
                    className="fc-card-header mb-20"
                    style={{ fontSize: "12px" }}
                  >
                    <span>Exclude these custom audiences</span>
                  </div>
                  <div className="fc-card-body" style={{ padding: "10px 0" }}>
                    <div className="common-input-container" data-label="Search">
                      {/* <input
              type="text"
              style={{ borderColor: "lightgray" }}
              placeholder="Search audiences"
            /> */}
                      <Field
                        type="text"
                        style={{ borderColor: "lightgray" }}
                        placeholder="Search audiences"
                        name="exclude"
                      />
                      <ErrorMessage
                        name="exclude"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>{" "}
                </div>
              </div>
              <div className="create-form-item">
                <div className="fc-card w-228">
                  <div className="fc-card-header" style={{ fontSize: "12px" }}>
                    <span>Languages</span>
                    <span className="fc-icon-edit">
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="fc-card-body" style={{ padding: "10px 0" }}>
                    <div
                      className="common-type-container"
                      data-label="Languages"
                    >
                      {/* <Select
              placeholder="select language"
              options={[
                { label: "Hindi", value: "Highest" },
                { label: "Japanese", value: "Lowest" },
              ]}
              styles={reactSelectStyles}
            /> */}

                      <Select
                        styles={reactSelectStyles}
                        options={[
                          { label: "Hindi", value: "Highest" },
                          { label: "Japanese", value: "Lowest" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("languages", selectedOptions)
                        }
                        value={values.languages}
                      />
                      <ErrorMessage
                        name="languages"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                  Advantage + audience
                </div>
                <p className="description">
                  We w'll automatically show ads to people most likely to
                  respond. We w'll show ads to people matching your suggestion
                  and other audiences when it's likely to improve.
                </p>
                <p className="link">About audiences</p>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <div className="f-16" style={{ fontWeight: "bold" }}>
                  Custom audiences
                </div>
              </div>
              <div className="create-form-item">
                <div
                  className="common-type-container"
                  data-label="Search Existing Audiences"
                  style={{ width: "350px" }}
                >
                  {/* <Select
          placeholder="Search Audiences"
          options={[
            { label: "chetan", value: "a1" },
            { label: "mahendra", value: "a2" },
          ]}
          styles={reactSelectStyles}
        /> */}
                  <Select
                    styles={reactSelectStyles}
                    placeholder="Search Audiences"
                    options={[
                      { label: "chetan", value: "a1" },
                      { label: "mahendra", value: "a2" },
                    ]}
                    onChange={(selectedOptions) =>
                      setFieldValue("existingAudience", selectedOptions)
                    }
                    value={values.existingAudience}
                  />
                  <ErrorMessage
                    name="existingAudience"
                    component="div"
                    className="text-red-500"
                  />
                </div>
                <div
                  className="common-type-container"
                  data-label="Create New"
                  style={{ width: "350px" }}
                >
                  {/* <Select
          placeholder="Audiences"
          options={[
            { label: "chetan", value: "a1" },
            { label: "mahendra", value: "a2" },
          ]}
          styles={reactSelectStyles}
        /> */}
                  <Select
                    styles={reactSelectStyles}
                    placeholder="Audiences"
                    options={[
                      { label: "chetan", value: "a1" },
                      { label: "mahendra", value: "a2" },
                    ]}
                    onChange={(selectedOptions) =>
                      setFieldValue("createNewAudience", selectedOptions)
                    }
                    value={values.createNewAudience}
                  />
                  <ErrorMessage
                    name="createNewAudience"
                    component="div"
                    className="text-red-500"
                  />
                </div>
              </div>
              <div className="fc-cards-container">
                <div className="fc-card w-228">
                  <div className="fc-card-header" style={{ fontSize: "12px" }}>
                    <span>Age</span>
                    <span className="fc-icon-edit">
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
                        />
                      </svg>
                    </span>
                  </div>
                  <div
                    className="fc-card-body"
                    style={{
                      padding: "10px 0",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    <div className="common-type-container" data-label="Min Age">
                      {/* <Select
              placeholder="age"
              options={[
                { label: "18", value: "18" },
                { label: "19", value: "19" },
                { label: "20", value: "20" },
              ]}
              styles={reactSelectStyles}
            /> */}
                      <Select
                        styles={reactSelectStyles}
                        placeholder="age"
                        options={[
                          { label: "18", value: "18" },
                          { label: "19", value: "19" },
                          { label: "20", value: "20" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("minAge", selectedOptions)
                        }
                        value={values.minAge}
                      />
                      <ErrorMessage
                        name="minAge"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div style={{ color: "lightgray", fontSize: "27px" }}>
                      -
                    </div>
                    <div className="common-type-container" data-label="Max Age">
                      {/* <Select
              placeholder="age"
              options={[
                { label: "20", value: "20" },
                { label: "21", value: "21" },
                { label: "22", value: "22" },
              ]}
              styles={reactSelectStyles}
            /> */}

                      <Select
                        styles={reactSelectStyles}
                        placeholder="age"
                        options={[
                          { label: "20", value: "20" },
                          { label: "21", value: "21" },
                          { label: "22", value: "22" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("maxAge", selectedOptions)
                        }
                        value={values.maxAge}
                      />
                      <ErrorMessage
                        name="maxAge"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </div>
                </div>

                <div className="fc-card w-228">
                  <div
                    className="fc-card-header mb-20"
                    style={{ fontSize: "12px" }}
                  >
                    <span>Gender</span>
                  </div>
                  <div className="fc-card-body" style={{ padding: "10px 0" }}>
                    <div className="common-type-container" data-label="Gender">
                      {/* <Select
              placeholder="select"
              options={[
                { label: "All genders", value: "18" },
                { label: "Male", value: "19" },
                { label: "Female", value: "20" },
                { label: "Others", value: "21" },
              ]}
              styles={reactSelectStyles}
            /> */}
                      <Select
                        styles={reactSelectStyles}
                        placeholder="select"
                        options={[
                          { label: "All genders", value: "all" },
                          { label: "Male", value: "male" },
                          { label: "Female", value: "female" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("gender", selectedOptions)
                        }
                        value={values.gender}
                      />
                      <ErrorMessage
                        name="gender"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </div>{" "}
                </div>
                <div className="fc-card w-228">
                  <div className="fc-card-header" style={{ fontSize: "12px" }}>
                    <span>Detailed Targeting</span>
                    <span className="fc-icon-edit">
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10.779 17.779 4.36 19.918 6.5 13.5m4.279 4.279 8.364-8.643a3.027 3.027 0 0 0-2.14-5.165 3.03 3.03 0 0 0-2.14.886L6.5 13.5m4.279 4.279L6.499 13.5m2.14 2.14 6.213-6.504M12.75 7.04 17 11.28"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="fc-card-body" style={{ padding: "10px 0" }}>
                    <p className="description">
                      {" "}
                      All demographics, interests and behaviours.
                    </p>
                  </div>
                </div>
              </div>
              <div className="create-form-item">
                <p className="link" style={{ textDecoration: "none" }}>
                  + Show more options
                </p>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                  Placements
                </div>
                <p className="description">
                  Choose where your ads appears across Meta technologies.
                </p>
                <p className="link">Learn more</p>
              </div>
              <div className="radio-container">
                <label
                  className={`radio-label ${
                    selected === "advantage" ? "selected" : ""
                  }`}
                >
                  {/* <input
          type="radio"
          name="placement"
          value="advantage"
          checked={selected === "advantage"}
          onChange={() => setSelected("advantage")}
        /> */}
                  <Field
                    type="radio"
                    name="placement"
                    value="advantage"
                    checked={values.placement === "advantage"}
                    onChange={() => setFieldValue("placement", "advantage")}
                  />
                  <ErrorMessage
                    name="placement"
                    component="div"
                    className="error-message"
                  />

                  <div>
                    <h3>
                      <span> Advantage + placements</span>{" "}
                      <span style={{ fontSize: "12px" }}>
                        {" (recommended)"}
                      </span>
                    </h3>
                    <p>
                      Use Advantage+ placements to maximize your budget and help
                      show your ads to more people. Facebook's delivery system
                      will allocate your ad set's budget across multiple
                      placements based on where they're likely to perform best.
                    </p>
                  </div>
                </label>

                <label
                  className={`radio-label ${
                    selected === "manual" ? "selected" : ""
                  }`}
                >
                  {/* <input
          type="radio"
          name="placement"
          value="manual"
          checked={selected === "manual"}
          onChange={() => setSelected("manual")}
        /> */}
                  <Field
                    type="radio"
                    name="placement"
                    value="manual"
                    checked={values.placement === "manual"}
                    onChange={() => setFieldValue("placement", "manual")}
                  />
                  <ErrorMessage
                    name="placement"
                    component="div"
                    className="error-message"
                  />

                  <div>
                    <h3>Manual placements</h3>
                    <p>
                      Manually choose the places to show your ad. The more
                      placements you select, the more opportunities you'll have
                      to reach your target audience and achieve your business
                      goals.
                    </p>
                  </div>
                </label>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AdsetName;
